import * as Tooltip from '@radix-ui/react-tooltip';
import type { ReactElement } from 'react';
import styles from './IconTooltip.module.css';

interface IconTooltipProps {
  label: string;
  children: ReactElement;
}

export const IconTooltip = ({ label, children }: IconTooltipProps) => (
  <Tooltip.Provider delayDuration={100}>
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content side="top" sideOffset={6} className={styles.content}>
          {label}
          <Tooltip.Arrow className={styles.arrow} />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>
);
